import { render, staticRenderFns } from "./DetailExame.vue?vue&type=template&id=19b149d6&scoped=true&"
import script from "./DetailExame.vue?vue&type=script&lang=js&"
export * from "./DetailExame.vue?vue&type=script&lang=js&"
import style0 from "./DetailExame.vue?vue&type=style&index=0&id=19b149d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b149d6",
  null
  
)

export default component.exports